module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Green_30.7b298639.png";